export const MIXPANEL_PREFIX = 'Agency Sign Up';
export const TRANSLATE_PREFIX = 'STATIC.PAGES.AGENCY_SIGNUP';
export const SIGNUP_TRANSLATE_PREFIX = 'STATIC.PAGES.SIGNUP';
export const SIGNUP_STATUS_SUCCESS = 'success';
